(() => {
  const EVENT_PREFIX = 'welshwords:';
  const ENQUIRY_ROUTE_STORAGE_KEY = 'welshwords:enquiry_route';
  const ENQUIRY_ROUTES = new Set([
    'lessons',
    'tutoring',
    'group',
    'english',
    'english_group',
    'welsh',
    'english_help',
    'one_to_one',
    'group_any',
    'course',
    'help',
    'general',
  ]);
  const NEWSLETTER_SOURCES = new Set(['homepage', 'article', 'footer']);

  const analyticsAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return false;

    if (typeof privacy.analyticsProcessingAllowed === 'function') {
      return privacy.analyticsProcessingAllowed() === true;
    }

    return privacy.value?.allowedProcessing?.analytics === true;
  };

  const publish = (name, data = {}) => {
    if (!analyticsAllowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    window.Shopify.analytics.publish(`${EVENT_PREFIX}${name}`, data);
  };

  const safePath = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin ? parsed.pathname : parsed.hostname;
    } catch {
      return 'unknown';
    }
  };

  const enquiryRouteFromUrl = (url = window.location.href) => {
    try {
      const route = new URL(url, window.location.origin).searchParams.get('enquiry');
      return ENQUIRY_ROUTES.has(route) ? route : 'none';
    } catch {
      return 'none';
    }
  };

  const lessonRouteFromUrl = (url = window.location.href) => {
    try {
      const parsed = new URL(url, window.location.origin);
      const view = parsed.searchParams.get('view');
      if (view === 'welsh-lessons' || parsed.pathname === '/pages/welsh-lessons') return 'welsh';
      if (view === 'english-lessons' || parsed.pathname === '/pages/english-lessons') return 'english';
      if (parsed.pathname === '/pages/language-lessons') return 'welsh_overview';
      return 'none';
    } catch {
      return 'none';
    }
  };

  const sourceArea = (link) => {
    if (link.closest('header')) return 'header';
    if (link.closest('footer')) return 'footer';
    if (link.closest('main')) return 'main';
    return 'other';
  };

  const newsletterSource = (element) => {
    const source = element?.dataset?.signupSource;
    return NEWSLETTER_SOURCES.has(source) ? source : 'other';
  };

  const currentEnquiryRoute = enquiryRouteFromUrl();

  const contactForm = document.querySelector('#ContactForm');
  const contactSuccess = document.querySelector('.contact__success');
  if (contactForm instanceof HTMLFormElement && !contactSuccess) {
    contactForm.addEventListener(
      'input',
      () => publish('contact_form_started', {
        page_path: window.location.pathname,
        enquiry_route: currentEnquiryRoute,
      }),
      { once: true },
    );
    contactForm.addEventListener('submit', () => {
      if (analyticsAllowed() && currentEnquiryRoute !== 'none') {
        try {
          window.sessionStorage.setItem(ENQUIRY_ROUTE_STORAGE_KEY, currentEnquiryRoute);
        } catch {}
      }
      publish('contact_form_submit_attempted', {
        page_path: window.location.pathname,
        enquiry_route: currentEnquiryRoute,
      });
    });
  }

  const newsletterForms = Array.from(document.querySelectorAll('[data-newsletter-form]'));
  newsletterForms.forEach((form) => {
    if (!(form instanceof HTMLFormElement)) return;
    const signupSource = newsletterSource(form);
    form.addEventListener(
      'input',
      () => publish('newsletter_signup_started', {
        page_path: window.location.pathname,
        signup_source: signupSource,
      }),
      { once: true },
    );
    form.addEventListener('submit', () => publish('newsletter_signup_submit_attempted', {
      page_path: window.location.pathname,
      signup_source: signupSource,
    }));

    const successMessage = form.querySelector('[data-newsletter-success]');
    if (successMessage) {
      requestAnimationFrame(() => successMessage.focus());
      publish('newsletter_signup_submitted', {
        page_path: window.location.pathname,
        signup_source: signupSource,
      });
    }
  });

  const newsletterSections = Array.from(document.querySelectorAll('[data-newsletter-signup]'));
  if (typeof IntersectionObserver === 'function') {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        publish('newsletter_signup_viewed', {
          page_path: window.location.pathname,
          signup_source: newsletterSource(entry.target),
        });
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    newsletterSections.forEach((section) => observer.observe(section));
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const href = link.getAttribute('href') || '';
    const label = link.textContent.trim().replace(/\s+/g, ' ').slice(0, 80);
    const commonData = {
      page_path: window.location.pathname,
      destination: safePath(link.href),
      source_area: sourceArea(link),
    };

    const destinationUrl = new URL(link.href, window.location.origin);
    const enquiryRoute = enquiryRouteFromUrl(destinationUrl);
    if (destinationUrl.origin === window.location.origin && destinationUrl.pathname === '/pages/contact' && enquiryRoute !== 'none') {
      publish('lesson_enquiry_cta_clicked', {
        ...commonData,
        enquiry_route: enquiryRoute,
        lesson_route: lessonRouteFromUrl(),
      });
    }

    if (href.startsWith('mailto:')) {
      publish('email_link_clicked', commonData);
    } else if (href.startsWith('tel:')) {
      publish('telephone_link_clicked', commonData);
    } else if (new URL(link.href, window.location.origin).hostname === 'learn.welshwords.com') {
      publish('app_link_clicked', commonData);
    } else if (link.classList.contains('button') || link.dataset.analyticsCta !== undefined) {
      publish('primary_cta_clicked', { ...commonData, label });
    }
  });

  const lessonRoute = lessonRouteFromUrl();
  if (lessonRoute !== 'none') {
    publish('lesson_page_viewed', {
      page_path: window.location.pathname,
      lesson_route: lessonRoute,
    });
  }

  if (contactForm instanceof HTMLFormElement && currentEnquiryRoute !== 'none') {
    publish('enquiry_form_viewed', {
      page_path: window.location.pathname,
      enquiry_route: currentEnquiryRoute,
    });
  }

  if (contactSuccess) {
    let successfulEnquiryRoute = currentEnquiryRoute;
    try {
      successfulEnquiryRoute = window.sessionStorage.getItem(ENQUIRY_ROUTE_STORAGE_KEY) || successfulEnquiryRoute;
      window.sessionStorage.removeItem(ENQUIRY_ROUTE_STORAGE_KEY);
    } catch {}
    publish('contact_form_submitted', {
      page_path: window.location.pathname,
      enquiry_route: ENQUIRY_ROUTES.has(successfulEnquiryRoute) ? successfulEnquiryRoute : 'none',
    });
  }
})();
